import React, { useEffect, useState } from 'react';

export const PhotoEvidenceModule = ({ value = [], onChange }) => {
  const [photos, setPhotos] = useState(value);

  useEffect(() => {
    setPhotos(value || []);
  }, [value]);

  const handleFiles = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    const readers = files.map((file) => new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve({
        id: Date.now() + Math.random(),
        name: file.name,
        size: file.size,
        type: file.type,
        dataUrl: reader.result,
      });
      reader.readAsDataURL(file);
    }));
    Promise.all(readers).then((newPhotos) => {
      const updated = [...photos, ...newPhotos];
      setPhotos(updated);
      onChange && onChange(updated);
      e.target.value = '';
    });
  };

  const removePhoto = (id) => {
    const updated = photos.filter((p) => p.id !== id);
    setPhotos(updated);
    onChange && onChange(updated);
  };

  const clearAll = () => {
    setPhotos([]);
    onChange && onChange([]);
  };

  return (
    <div className="mt-4 border rounded-lg p-4 bg-gray-50">
      <div className="flex items-center justify-between mb-2">
        <label className="font-semibold">Registro fotográfico (opcional)</label>
        {photos.length > 0 && (
          <button type="button" onClick={clearAll} className="text-sm text-red-600 hover:underline">Limpiar</button>
        )}
      </div>
      <input
        type="file"
        accept="image/*"
        multiple
        onChange={handleFiles}
        className="w-full border rounded px-3 py-2"
      />
      {photos.length > 0 && (
        <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {photos.map((p) => (
            <div key={p.id} className="border rounded overflow-hidden bg-white">
              <img src={p.dataUrl} alt={p.name} className="w-full h-32 object-cover" />
              <div className="p-2 text-xs flex items-center justify-between">
                <span className="truncate" title={p.name}>{p.name}</span>
                <button type="button" onClick={() => removePhoto(p.id)} className="text-red-600 hover:underline">Quitar</button>
              </div>
            </div>
          ))}
        </div>
      )}
      {photos.length === 0 && (
        <p className="text-xs text-gray-600 mt-2">Adjunte una o varias imágenes como evidencia Nota: Max-5MB.</p>
      )}
    </div>
  );
};